/* v8 ignore start */

// Runtime environment variables loaded from env.js
// @ts-expect-error - env is loaded from external script in index.html
const runtimeVariables: Record<string, unknown> = typeof env !== 'undefined' ? env : {};

interface AzureAdConfig {
  tenantId?: string;
  clientId?: string;
}

interface RuntimeEnv {
  backendUrl?: string;
  environment?: string;
  version?: string;
  azureAd?: AzureAdConfig;
  disableAuth?: boolean;
}

export default {
  backendUrl: (runtimeVariables as RuntimeEnv).backendUrl as string || process.env.REACT_APP_BACKEND_URL || '/api',
  environment: (runtimeVariables as RuntimeEnv).environment as string || 'local',
  version: (runtimeVariables as RuntimeEnv).version as string || '1.0.0',
  disableAuth: (runtimeVariables as RuntimeEnv).disableAuth as boolean || process.env.DISABLE_AUTH === 'true' || false,
  azureAd: {
    tenantId: ((runtimeVariables as RuntimeEnv).azureAd?.tenantId as string) || process.env.REACT_APP_AZURE_AD_TENANT_ID || '',
    clientId: ((runtimeVariables as RuntimeEnv).azureAd?.clientId as string) || process.env.REACT_APP_AZURE_AD_CLIENT_ID || '',
  }
} as const;
